import {differenceInHours, parseISO} from 'date-fns';

export const differenceInWholeHours = (laterAt: string, earlierAt: string) =>
  differenceInHours(parseISO(laterAt), parseISO(earlierAt));
